import { ReturnRequestDto } from "@babackapp/private-api-client/types";

export function getFinancialDiscountChargesAmount(
  returnRequest: ReturnRequestDto,
  chargeForRefund?: boolean,
  chargeForInitialShipping?: boolean,
  forceRefundInitialShipping?: boolean,
) {
  let charges = 0;
  const fi = returnRequest.financial_informations;
  if (
    fi.return_shipping_paid?.method === "discount" &&
    fi.return_shipping_paid.presentment_amount > 0 &&
    chargeForRefund
  ) {
    charges += fi.return_shipping_paid.presentment_amount;
  }
  if (
    fi.initial_shipping_refunded?.method === "discount" &&
    fi.initial_shipping_refunded.presentment_amount > 0 &&
    chargeForInitialShipping &&
    !forceRefundInitialShipping
  ) {
    charges -= Math.min(
      fi.initial_shipping_refunded.presentment_amount,
      fi.initial_shipping_refunded.fixedAmount < 0
        ? Number.POSITIVE_INFINITY
        : fi.initial_shipping_refunded.fixedAmount,
    );
  }
  if (
    fi.initial_shipping_refunded?.method === "discount" &&
    fi.initial_shipping_refunded.presentment_amount === 0 &&
    forceRefundInitialShipping
  ) {
    charges -= Math.min(
      fi.initial_shipping_refunded.sourceAmount,
      fi.initial_shipping_refunded.fixedAmount < 0
        ? Number.POSITIVE_INFINITY
        : fi.initial_shipping_refunded.fixedAmount,
    );
  }
  return charges;
}
